import { render, staticRenderFns } from "./recently-bought.vue?vue&type=template&id=0589860c&scoped=true"
import script from "./recently-bought.vue?vue&type=script&lang=js"
export * from "./recently-bought.vue?vue&type=script&lang=js"
import style0 from "./recently-bought.vue?vue&type=style&index=0&id=0589860c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589860c",
  null
  
)

export default component.exports